import moment from "moment";

export const formatDate = (date) => {
  if (!date || !moment(date).isValid()) return "";
  const m = moment(date);
  return m.format("DD MMM YYYY");
};

export const formatTime = (date) => {
  if (!date || !moment(date).isValid()) return "";
  const m = moment(date);
  return m.format("hh:mm A");
};

